<template>
<div
    :class="{'todo-container' : true, 'todo-container-clickable': clickable }"
    v-on:click="onClickContainer"
>
    <div
        :class="{ 'todo-text': true, 'todo-clickable': clickable }"
    >
        {{label}}
    </div>

    <div 
        class ="todo-state"
        :style="state_style"
    >
        {{$rc.pretty(state,'enum_welcome_task_state')}}
    </div>

</div>
</template>

<script>
export default {
    props: {
        
        label: {
            type: String,
            default: function() { return null; }
        },

        state: {
            type: String,
            default: function() { return 'not-applicable'; }
        },

        clickable: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        onClickContainer() {
            if ( this.clickable )
            {
                this.$emit('click');
            }
        }
    },

    computed: {
        state_style() {

            if ( this.state == 'waiting-on-client' ) return 'background-color: rgba(0,0,0,0.05);';
            if ( this.state == 'pending' || this.state == 'needs-confirmation' ) return 'background-color: rgba(240,200,100,0.5);';
            if ( this.state == 'done' ) return 'background-color: rgba(0,255,0,0.3);';
            if ( this.state == 'not-applicable' ) return 'background-color: rgba(0,0,0,0.02); color: rgba(0,0,0,0.3);';

            return '';
        },
    },
}
</script>

<style lang="scss" scoped>

.todo-container
{
    display: flex;
    align-items: center;

    border-bottom: 1px solid rgb(235,235,235);
    border-top: 1px solid rgb(235,235,235);

    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: -1px;
}

.todo-clickable
{
    text-decoration: underline;

}

.todo-container-clickable
{
    cursor: pointer;
}

.todo-text
{
    flex-grow: 1;
    
}

.todo-state
{
    flex-grow: 0;
    border-radius: 7px;
    padding: 10px;

    width: 250px;
    text-align: center;
    font-weight: 700;
}

</style>